import { render, staticRenderFns } from "./UserDeeds.vue?vue&type=template&id=20aceafa&scoped=true&"
import script from "./UserDeeds.vue?vue&type=script&lang=js&"
export * from "./UserDeeds.vue?vue&type=script&lang=js&"
import style0 from "./UserDeeds.vue?vue&type=style&index=0&id=20aceafa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aceafa",
  null
  
)

export default component.exports